import Vue from "vue";
import ConfirmDialog from "../components/cards/VueConfirmDialog.vue";

const confirm = {
  install(Vue) {
    Vue.prototype.$confirm = function (options) {
      return new Promise((resolve) => {
        // Create a wrapper component that will handle the confirmation dialog
        const DialogWrapper = Vue.extend({
          render(h) {
            return h(ConfirmDialog, {
              props: {
                show: this.isVisible,
                title: options.title || "Confirm Action",
                message: options.message || "Are you sure you want to proceed?",
                button: {
                  yes: options.confirmButtonText || "Oui",
                  no: options.cancelButtonText || "Non",
                },
              },
              on: {
                confirm: () => {
                  this.isVisible = false;
                  this.$nextTick(() => {
                    this.$el.parentNode.removeChild(this.$el);
                    this.$destroy();
                    resolve(true);
                  });
                },
                cancel: () => {
                  this.isVisible = false;
                  this.$nextTick(() => {
                    this.$el.parentNode.removeChild(this.$el);
                    this.$destroy();
                    resolve(false);
                  });
                },
              },
            });
          },
          data() {
            return {
              isVisible: true,
            };
          },
        });

        const wrapper = new DialogWrapper().$mount();
        document.body.appendChild(wrapper.$el);
      });
    };
  },
};

export default confirm;
